import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Switch from 'flarum/common/components/Switch';
import Api from '../utils/Api';
// v0.19.22 — 后端错误文案的**共用入口** (三级兜底, 与本文件历史手抄版逐字等价)
import { errReason } from '../utils/FormPrimitives';

/**
 * v0.5.0v — 新建 / 编辑校区 Modal
 *
 * 严格按设计图 /Users/zhaozihui/.mavis/agents/mavis/workspace/designs/school-editor-modal.html
 * 风格跟 RoomEditorModal (v0.5.0m) 同款: Flarum 原生 Modal + className() / title() / content()
 */
export default class SchoolEditorModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.school = vnode.attrs.school;
    this.onCloseCb = vnode.attrs.onClose;
    this.saving = false;
    this.error = '';
    this.form = this.school ? {
      ...this.school
    } : {
      name: '',
      status: 'enabled',
      // v0.19.15 — 新建校区时开关默认**关** (与 DB 的 default 0 同口径)
      allow_self_booking: false
    };
  }
  className() {
    return 'Modal--medium SchoolEditorModal';
  }
  title() {
    return m("span", null, m("i", {
      className: "fas fa-location-dot",
      style: "color:var(--zs-brand-2d7be5, #2d7be5);margin-right:6px;"
    }), this.school ? '编辑校区' : '新建校区');
  }
  validate() {
    if (!this.form.name || !String(this.form.name).trim()) return '请填写校区名称';
    return null;
  }
  async submit() {
    const err = this.validate();
    if (err) {
      this.error = err;
      m.redraw();
      return;
    }
    this.error = '';
    this.saving = true;
    m.redraw();
    try {
      const payload = {
        name: String(this.form.name).trim(),
        status: this.form.status || 'enabled',
        // v0.19.15 — 「允许学员自主约课」开关。
        //   ⛔ **随这一次提交一起发** (不另发一次请求): 新建/编辑走同一个 payload,
        //      少发一次 = 新建时那个开关会被静默丢掉。
        //   ⚠️ 发 1 / 0 而不是 true / false —— 后端用 `array_key_exists` + `(bool)(int)` 归一,
        //      1/0 与那一列 (tinyint) 同形。⛔ 后端**不能**用 isset (false 会被吃掉 ⇒ 关不掉)。
        allow_self_booking: this.form.allow_self_booking ? 1 : 0
      };
      if (this.school && this.school.id) {
        await Api.update('schools', this.school.id, payload);
      } else {
        await Api.create('schools', payload);
      }
      this.saving = false;
      if (this.onCloseCb) this.onCloseCb();
      this.hide();
    } catch (e) {
      this.saving = false;
      // v0.17.65 — 为什么不能只看 `e.message` (改前这里只有 `|| '保存失败'`)
      //   后端抛 ValidationException 时 HTTP 是 422, **真实原因在 `e.response.errors[0].detail`**;
      //   `e.message` 只是请求层拼的 "Response code 422 (Unprocessable Entity)", 跟后端那句提示无关。
      //   后果: 校区重名 / 字段非法这类**可操作**的原因被吞成「保存失败」, 用户不知道要改哪个字段。
      //   形状照抄同仓既有正确写法 (CalendarTab.js:2770 / modal/FixedLessonModal.js:593);
      //   兜底文案「保存失败」保留不变, 只是降为最后一档 (网络层异常 / 非 422 时仍命中)。
      this.error = errReason(e, '保存失败');
      console.error('[school-editor] save failed', e);
      m.redraw();
    }
  }
  content() {
    return m("div", null, m("div", {
      className: "Modal-body"
    }, m("div", {
      style: "font-size:12px;color:var(--zs-text-2-8d96a3, #8d96a3);margin-bottom:16px;"
    }, "\u586B\u5199\u6821\u533A\u540D\u79F0, \u4FDD\u5B58\u540E\u53EF\u5206\u914D\u6559\u7EC3\u548C\u9500\u552E"), m("div", {
      className: "ZS-form-row"
    }, m("label", null, m("i", {
      className: "fas fa-building",
      style: "color:var(--zs-text-2-8d96a3, #8d96a3);"
    }), " \u6821\u533A\u540D\u79F0 ", m("span", {
      style: "color:var(--zs-danger-ff6058, #ff6058);"
    }, "*")), m("input", {
      className: "ZS-form-input",
      placeholder: "\u4F8B: \u671D\u9633\u6821\u533A",
      value: this.form.name,
      oninput: ev => {
        this.form.name = ev.target.value;
        m.redraw();
      }
    }), m("div", {
      style: "font-size:11px;color:var(--zs-text-2-8d96a3, #8d96a3);margin-top:4px;"
    }, "\u6821\u533A\u663E\u793A\u5728\u8BBA\u575B\u9876\u90E8\u4E0B\u62C9 + \u5B66\u5458/\u6559\u7EC3/\u9500\u552E\u5206\u914D\u5217\u8868")), m("div", {
      className: "ZS-form-row"
    }, m("label", null, m("i", {
      className: "fas fa-toggle-on",
      style: "color:var(--zs-text-2-8d96a3, #8d96a3);"
    }), " \u72B6\u6001"), m("div", {
      style: "display:flex;align-items:center;gap:10px;padding:10px 12px;background:var(--zs-surface-4-0e1116, #0e1116);border:1px solid var(--zs-overlay-1-255-255-255-008, rgba(255,255,255,0.08));border-radius:8px;"
    }, m("span", {
      style: "flex:1;display:inline-flex;align-items:center;gap:6px;"
    }, m("i", {
      className: "fas fa-circle-check",
      style: {
        color: this.form.status === 'enabled' ? '#34c759' : 'var(--zs-text-2-8d96a3, #8d96a3)'
      }
    }), "\u542F\u7528\u6B64\u6821\u533A"), m(Switch, {
      state: this.form.status === 'enabled',
      onchange: checked => {
        this.form.status = checked ? 'enabled' : 'disabled';
        m.redraw();
      }
    }), m("span", {
      style: {
        fontSize: '12px',
        fontWeight: 600,
        color: this.form.status === 'enabled' ? '#34c759' : 'var(--zs-text-2-8d96a3, #8d96a3)',
        minWidth: '28px',
        textAlign: 'right'
      }
    }, this.form.status === 'enabled' ? '启用' : '停用'))), m("div", {
      className: "ZS-form-row"
    }, m("label", null, m("i", {
      className: "fas fa-user-clock",
      style: "color:var(--zs-text-2-8d96a3, #8d96a3);"
    }), " \u5B66\u5458\u81EA\u4E3B\u7EA6\u8BFE"), m("div", {
      style: "display:flex;align-items:center;gap:10px;padding:10px 12px;background:var(--zs-surface-4-0e1116, #0e1116);border:1px solid var(--zs-overlay-1-255-255-255-008, rgba(255,255,255,0.08));border-radius:8px;"
    }, m("span", {
      style: "flex:1;display:inline-flex;align-items:center;gap:6px;"
    }, m("i", {
      className: "fas fa-user-clock",
      style: {
        color: this.form.allow_self_booking ? 'var(--zs-success-34c759, #34c759)' : 'var(--zs-text-2-8d96a3, #8d96a3)'
      }
    }), "\u5141\u8BB8\u5B66\u5458\u81EA\u4E3B\u7EA6\u8BFE"), m(Switch, {
      state: !!this.form.allow_self_booking,
      onchange: checked => {
        this.form.allow_self_booking = checked;
        m.redraw();
      }
    }), m("span", {
      style: {
        fontSize: '12px',
        fontWeight: 600,
        color: this.form.allow_self_booking ? 'var(--zs-success-34c759, #34c759)' : 'var(--zs-text-2-8d96a3, #8d96a3)',
        minWidth: '28px',
        textAlign: 'right'
      }
    }, this.form.allow_self_booking ? '开启' : '关闭')), m("div", {
      style: "font-size:11px;color:var(--zs-text-2-8d96a3, #8d96a3);margin-top:4px;"
    }, "\u5F00\u542F\u540E, \u8BE5\u6821\u533A\u7684\u5B66\u5458\u53EF\u5728\u300C\u6211\u7684\u5361\u7247\u300D\u91CC\u81EA\u884C\u9884\u7EA6\u8BFE\u6B21; \u5173\u95ED\u5219\u4ECD\u7531\u524D\u53F0\u4EE3\u7EA6")), this.error && m("div", {
      className: "ZS-newversion-error",
      style: "margin-top:8px;"
    }, m("i", {
      className: "fas fa-triangle-exclamation",
      style: "color:var(--zs-danger-ef4444, #ef4444);margin-right:6px;"
    }), this.error)), m("div", {
      className: "Modal-footer"
    }, m("button", {
      className: "Button",
      onclick: () => this.hide()
    }, m("i", {
      className: "fas fa-xmark"
    }), " \u53D6\u6D88"), m("button", {
      className: "Button Button--primary",
      disabled: this.saving,
      onclick: () => this.submit()
    }, m("i", {
      className: "fas fa-check"
    }), " ", this.saving ? '保存中...' : '保存校区')));
  }
}
flarum.reg.add('ziiven-ziven-scheduler', 'forum/modal/SchoolEditorModal', SchoolEditorModal);